import { render, staticRenderFns } from "./GoalsetSelect.vue?vue&type=template&id=24083df8"
import script from "./GoalsetSelect.ts?vue&type=script&lang=ts&external"
export * from "./GoalsetSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports